// Generated by ReScript, PLEASE EDIT WITH CARE


function baseRoute(text, param) {
  if (text !== undefined) {
    return "/loading/" + text;
  } else {
    return "/loading";
  }
}

export {
  baseRoute,
}
/* No side effect */
